import React, { Component } from 'react';
import wx from 'weixin-js-sdk';
import { GetRequest } from "../../utils/util";
import { Toast } from 'antd-mobile'

var browser = {
    versions: function () {
        var u = navigator.userAgent;
        return {
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 || u.indexOf('Linux') > -1, //android终端
        };
    }(),
}

class AuthenticateSuccess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            countdown: 5,
            projectId: null,
            accountId: null,
            isSuccess: false,
            isLoading: true,
            errorText: ''
        };
        this.timer = null;
    }

    componentDidMount() {
        document.title = "认证成功"
        let search = window.location.search.slice(1)
        let params = search.split('&')
        var theRequest = new Object()
        for (let i = 0; i < params.length; i++) {
            theRequest[params[i].split("=")[0]] = decodeURIComponent(params[i].substring(params[i].indexOf('=') + 1));
        }

        if (theRequest.accountInfo == null) {
            Toast.show({
                content: '系统异常！'
            })
        } else {
            let accountInfo = JSON.parse(theRequest?.accountInfo)
            this.setState({
                projectId: accountInfo.projectId,
                accountId: accountInfo.accountId
            })
            const paramsInfo = new URLSearchParams({
                projectId: accountInfo.projectId,
                accountId: accountInfo.accountId,
                ticket: theRequest?.ticket
            });

            let urlCas = accountInfo?.urlCas
            const url = `${urlCas}?${paramsInfo.toString()}`;

            fetch(url)
                .then(response => response.json())
                .then(data => {
                    this.setState({
                        isLoading: false,
                        isSuccess: data.errorCode == '200' ? true : false,
                        errorText: data.message
                    })
                })
                .catch(error => console.error('Error:', error));

            this.startCountdown();
        }

    }

    // 返回趣智校园
    onBack = () => {
        // wx
        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            wx.miniProgram.getEnv((res) => {
                if (res.miniprogram) {
                    console.log('在wx小程序内');
                    let data = GetRequest();
                    wx.miniProgram.switchTab({
                        url: '/pages/index/index'
                    })
                    return;
                }
            })
            return;
        }

        // zfb
        if (/Alipay/i.test(navigator.userAgent)) {
            window.location.href = "alipays://platformapi/startapp?appId=2018090661238647&page=pages/index/index"
            return;
        }

        // app
        var userAgent = navigator.userAgent;
        const OpenHarmony = /(OpenHarmony).*?/.test(userAgent);
        if (browser.versions.android || OpenHarmony) {
            window.android.onCampusPayExit();
            return;
        }
        if (browser.versions.ios) {
            window.webkit.messageHandlers.onCampusPayExit.postMessage('');
            return;
        }
    }

    componentWillUnmount() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }

    // 倒计时逻辑
    startCountdown = () => {
        this.timer = setTimeout(() => {
            if (this.state.countdown <= 1) {
                this.onBack();
            } else {
                this.setState(
                    prevState => ({ countdown: prevState.countdown - 1 }),
                    this.startCountdown
                );
            }
        }, 1000);
    };

    // 立即跳转处理
    handleClick = () => {
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.onBack();
    };

    render() {
        const { projectId, accountId, isLoading } = this.state
        return (<>
            {!isLoading && projectId && accountId ? <div style={{
                textAlign: 'center',
                marginTop: '8vh'
            }}>
                <img style={{ width: '120px' }} src={this.state.isSuccess ? require('../../assets/wancheng.png') : require('../../assets/icon-close-warn.png')} /> {/* 失败 require('../../assets/wancheng.png') */}
                <div style={{
                    fontSize: '18px',
                    marginTop: '20px'
                }}>{this.state.isSuccess ? '认证成功' : '认证失败'}</div>
                <div style={{
                    fontSize: '15px',
                    color: '#999',
                    marginTop: '10px'
                }}>{this.state.isSuccess ? '恭喜你，完成了身份认证，点击完成返回' : this.state.errorText}</div>
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop: '50px'
                }}>
                    <button
                        onClick={this.handleClick}
                        style={{
                            width: '300px',
                            padding: '8px 0',
                            fontSize: '16px',
                            background: 'linear-gradient( 270deg, #5BA1FD 0%, #6FBDFF 100%)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '30px',
                            cursor: 'pointer'
                        }}
                    >
                        完成（{this.state.countdown}s）
                    </button>
                </div>
            </div> : null}
        </>);
    }
}

export default AuthenticateSuccess;
